import { useAPIRequest } from '~/composables/api/useAPIRequest'
import type { LandingPagesListingResponse } from '~/types/api/LandingPagesListing'

export async function useReferencesListing() {
  return (await useAPIRequest(
    '/reference-landing-pages'
  )) as LandingPagesListingResponse
}
